import Stack from '../Stack';
import styled from 'styled-components';

export const StyledStack = styled(Stack)`
    flex: 1;
`;
